import { action, computed, makeObservable } from 'mobx';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {McqModel, McqSingleSelectState} from '../models';

export class SingleSelectMcqStore {
  constructor(readonly id: number,
              readonly model: McqModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
  }

  @computed
  get state(): McqSingleSelectState | null {
    const altState = { selectedIndex: null, checked: false}
    return this.stateStore.getContentState<McqSingleSelectState>(this.id) ? this.stateStore.getContentState<McqSingleSelectState>(this.id) : altState;
  }

  @action
  select = (index: number) => {
    let state = this.state;
    if (state === null)
      return;

    if (state.selectedIndex === index)
      return;
    this.stateStore.setContentState<McqSingleSelectState>(
      this.id,
      {
        selectedIndex: index,
        checked: false
      });
  };

  @action
  check = () => {
    let state = this.state;
    if (state === null)
      return;

    if (state.selectedIndex === null || state.checked) return;

    this.stateStore.setContentState<McqSingleSelectState>(
      this.id,
      {
        selectedIndex: state.selectedIndex,
        checked: true
      });
  };
}
